import {ENDPOINTS} from '../common/endpoints';
import {
    IFinancePeriodQuery,
    IFinanceSummary,
    IFinanceTransactionsPage,
    IFinanceTransactionsQuery,
    IManualExpense,
    ISaveManualExpense,
} from '@mybake/ui/models/Finances/IFinance';
import {baseAPI} from './BaseAPI';
import {TAGS} from './TagTypes';

export const financeAPI = baseAPI.injectEndpoints({
    endpoints: (build) => ({
        getFinanceSummary: build.query<IFinanceSummary, IFinancePeriodQuery>({
            query: (params) => ({
                url: ENDPOINTS.FINANCES.SUMMARY,
                method: 'GET',
                params,
            }),
            providesTags: [TAGS.FINANCES],
        }),
        getFinanceTransactions: build.query<IFinanceTransactionsPage, IFinanceTransactionsQuery>({
            query: (params) => ({
                url: ENDPOINTS.FINANCES.TRANSACTIONS,
                method: 'GET',
                params,
            }),
            providesTags: [TAGS.FINANCES],
        }),
        getExpenseCategories: build.query<string[], string>({
            query: (search) => ({
                url: ENDPOINTS.FINANCES.EXPENSE_CATEGORIES,
                method: 'GET',
                params: search ? {search} : undefined,
            }),
            providesTags: [TAGS.EXPENSE_CATEGORIES],
        }),
        createManualExpense: build.mutation<IManualExpense, ISaveManualExpense>({
            query: (body) => ({
                url: ENDPOINTS.FINANCES.EXPENSES,
                method: 'POST',
                body,
            }),
            invalidatesTags: [TAGS.FINANCES, TAGS.EXPENSE_CATEGORIES],
        }),
        updateManualExpense: build.mutation<IManualExpense, {id: string; body: ISaveManualExpense}>({
            query: ({id, body}) => ({
                url: `${ENDPOINTS.FINANCES.EXPENSES}/${id}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: [TAGS.FINANCES, TAGS.EXPENSE_CATEGORIES],
        }),
        deleteManualExpense: build.mutation<void, string>({
            query: (id) => ({
                url: `${ENDPOINTS.FINANCES.EXPENSES}/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: [TAGS.FINANCES, TAGS.EXPENSE_CATEGORIES],
        }),
    }),
});
